<template>
	<div class="passwordvalidator w-100">
		<input autocomplete="off" type="password"
		ref="password" @focus="focusPassword()" @blur="focusOutPassword()" @keyup="keyupPassword()"
		:class="inputclass" :placeholder="inputplaceholder" :name="inputname" :value='value'
		@input="updateValue()" />
		<div class="card m-t-xs" :class="{'hide d-none': !showPopoverPV,'right': position == 'right', 'top': position == 'top'}" >
			<div class="arrow"></div>
			<div class="card-header">Password Requirement</div>
			<div class="card-body">
				<ul v-html="parentMessage" class="list-group list-group-flush">
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: ["value", "inputclass", "inputplaceholder","inputname","position"],
  created() {

  },
  data() {
    return {
      parentMessage: "",
      showPopoverPV: false,
      position : "right"
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.$refs.password.value);
    },
    focusPassword() {
        this.showPopoverPV = true;
        this.checkPasswordCriteria();
    },
    focusOutPassword(){
        this.showPopoverPV = false;
    },
    keyupPassword() {
        this.checkPasswordCriteria();
    },
    checkPasswordCriteria() {
        var password = this.value;
        var checkHtml = '<i class="material-icons" style="color:green;">check';
        var uncheckHtml = '<i class="material-icons" style="color:red;">close';
        var upperCase = new RegExp('[A-Z]');
        var lowerCase = new RegExp('[a-z]');
        var numbers = new RegExp('[0-9]');
        var spChar = /[`!@#$%^&*()_=+\-\{\}\[\]|\\":;,./?]/g;
        var html = '<li class="list-group-item text-left">';
        if (password == null || password.length < 8 || password.length > 25)
            html += uncheckHtml;
        else
            html += checkHtml;
        html += '</i> Minimum 8 and Maximum 25 in length.</li><li class="list-group-item text-left">';
        if (password && password.match(lowerCase))
            html += checkHtml;
        else
            html += uncheckHtml;
        html += '</i> At least 1 lower case letter.</li><li class="list-group-item text-left">';
        if (password && password.match(upperCase))
            html += checkHtml;
        else
            html += uncheckHtml;
        html += '</i> At least 1 upper case letter.</li><li class="list-group-item text-left">';
        if (password && password.match(numbers))
            html += checkHtml;
        else
            html += uncheckHtml;
        html += '</i> At least 1 digit.</li>';

       /* if (password && password.match(spChar))
            html += checkHtml;
        else
            html += uncheckHtml;

        html += '</i> Contains at least 1 special character</li>';*/

        this.parentMessage = html;
    }
  }
};
</script>
